// extracted by mini-css-extract-plugin
export default {"container":"styles_container__O6Vd0","tabs":"styles_tabs__EWIta","content":"styles_content__n4alp","graphic":"styles_graphic__LgRd3"};